import component from './zh-TW/component';
import globalHeader from './zh-TW/globalHeader';
import menu from './zh-TW/menu';
import pages from './zh-TW/pages';
import pwa from './zh-TW/pwa';
import settingDrawer from './zh-TW/settingDrawer';
import settings from './zh-TW/settings';
import fixOverlay from './zh-TW/fix_overlay';
import fixOpenapi from './zh-TW/fix_openapi';
import fixAdminMisc from './zh-TW/fix_adminmisc';
import fixBilling from './zh-TW/fix_billing';
import fixComponents from './zh-TW/fix_components';
import fixConsoleMisc from './zh-TW/fix_consolemisc';
import fixGap from './zh-TW/fix_gap';
import fixSystemconfig from './zh-TW/fix_systemconfig';
import fixTenant from './zh-TW/fix_tenant';
import fixVoiceClone from './zh-TW/fix_voiceclone';
import fixTodo from './zh-TW/fix_todo';
import fixLedger from './zh-TW/fix_ledger';


export default {
  'navBar.lang': '�Z��',
  'layout.user.link.help': '����',
  'layout.user.link.privacy': '�[˽',
  'layout.user.link.terms': '�l��',
  'app.preview.down.block': '���d����浽�����Ŀ',
  'app.welcome.link.fetch-blocks': '�@ȡ���ЉK',
  'app.welcome.link.block-list': '���� block �_�l�����٘����˜����',
  ...fixConsoleMisc,
  ...fixComponents,
  ...fixAdminMisc,
  ...fixBilling,
  ...fixTenant,
  ...fixVoiceClone,
  ...fixGap,
  ...fixSystemconfig,
  ...fixOpenapi,
  ...fixTodo,
  ...fixLedger,
};
